import cx from 'classnames';
import {
  IPaginationProps,
  Pagination as UiPagination,
} from 'components/ui/Pagination';
import css from './Pagination.module.scss';

export const Pagination = ({ className, ...rest }: IPaginationProps) => (
  <UiPagination className={cx(css.pagination, className)} {...rest} />
);
